import React, { useState, useEffect, useRef, useCallback } from "react";
import { FaBars } from "react-icons/fa";
import { Link } from "react-router-dom";
import authService from "../services/authService";
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [isMobileLoginOpen, setIsMobileLoginOpen] = useState(false);
  const [user, setUser] = useState(authService.getCurrentUser());
  const desktopDropdownRef = useRef(null);
  const mobileDropdownRef = useRef(null);
  const navigate = useNavigate();

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (desktopDropdownRef.current && !desktopDropdownRef.current.contains(event.target)) {
        setIsLoginOpen(false);
      }

      if (mobileDropdownRef.current && !mobileDropdownRef.current.contains(event.target)) {
        setIsMobileLoginOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Function to fetch profile data
  const fetchProfile = useCallback(async () => {
    const currentUser = authService.getCurrentUser();
    if (!currentUser) {
      console.log("No user found, user remains null.");
      return;
    }

    try {
      const response = await fetch("https://doshfebackend.teemah.com.ng/api/auth/profile/", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${currentUser.access}`,
        },
      });

      if (!response.ok) {
        console.error("Failed to fetch profile:", response.status);
        return;
      }

      const data = await response.json();
      console.log("Fetched user data:", data);

      if (data.completed) {
        setUser(data);
        console.log("User state updated:", data);
      } else {
        console.log("User profile exists but is not completed.");
        setUser(null);
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  }, []);

  // Fetch profile only if user is logged in and profile data is not available
  useEffect(() => {
    if (user && !user.completed) {
      fetchProfile();
    }
  }, [user, fetchProfile]);

  // Function to determine the greeting
  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return "Good morning";
    if (hour < 18) return "Good afternoon";
    return "Good evening";
  };

  // Listen for user updates
  useEffect(() => {
    const updateUser = () => setUser(authService.getCurrentUser());
    window.addEventListener("userUpdated", updateUser);
    return () => window.removeEventListener("userUpdated", updateUser);
  }, []);

  const handleLogout = () => {
    authService.logout(); // Clears localStorage
    setUser(null); // Immediately update UI
    setIsLoginOpen(false);
    navigate("/"); // Redirect user
    window.location.reload(); // Ensure full refresh
  };

  return (
    <div className="z-50">
      <nav className="bg-yellow-500 px-6 py-4 fixed top-0 w-full shadow-md flex justify-between items-center z-10">
        <h1 className="text-3xl font-bold text-yellow cursor-pointer">
          <Link to="/">
            <img src="/dca1.png" alt="Dosh Learning Hub" className="w-16" />
          </Link>
        </h1>

        <div className="relative" ref={desktopDropdownRef}>
          {user ? (
            <div className="flex items-center space-x-3 cursor-pointer" onClick={() => setIsLoginOpen(!isLoginOpen)}>
              <img src={user.profile_picture} alt="Profile" className="w-12 h-12 rounded-full border-2 border-white" />
              <em>
                <span className="text-blue-600 font-medium">
                  {getGreeting()}, {user.first_name}
                </span>
              </em>
            </div>
          ) : (
            <button
              onClick={() => setIsLoginOpen(!isLoginOpen)}
              className="bg-blue text-yellow-100 px-6 py-2 rounded-tr-lg rounded-bl-lg bg-blue-600 shadow-lg font-medium hover:bg-yellow transition"
            >
              Login
            </button>
          )}

          {isLoginOpen && (
            <div className="absolute top-12 right-0 bg-gradient-to-r from-blue-500 to-yellow-400 shadow-lg rounded-md w-48 py-2">
              <ul className="text-black">
                {user ? (
                  <>
                    <li className="px-4 py-2 hover:bg-gray-200 cursor-pointer">
                      <Link to="/dashboard" onClick={() => setIsLoginOpen(false)}>Return To Dashboard</Link>
                    </li>
                    <hr />
                    <li className="px-4 py-2 hover:bg-gray-200 cursor-pointer">
                      <button onClick={handleLogout}>Logout</button>
                    </li>
                  </>
                ) : (
                  <>
                    <li className="px-4 py-2 hover:bg-gray-200 cursor-pointer">
                      <Link to="/login" onClick={() => setIsLoginOpen(false)}>Login to Registration/Resources</Link>
                    </li>
                    <hr />
                    <li className="px-4 py-2 hover:bg-gray-200 cursor-pointer">
                      <a 
                        href="http://doshcodingacademy.teemah.com.ng/" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        onClick={() => setIsLoginOpen(false)}
                      >
                        Login to LMS
                      </a>
                    </li>
                  </>
                )}
              </ul>
            </div>
          )}
        </div>
      </nav>
    </div>
  );
};

export default Navbar;